export default function getQueryParam(name: string) {
  return useRequestURL().searchParams.get(name);
}
